import React from "react";
import { Modal } from "antd";
// import { createStyles, useTheme } from "antd-style";
// const useStyle = createStyles(({ token }) => ({
//   "my-modal-body": {
//     // background: token.blue1,
//     // padding: token.paddingSM,
//   },
//   "my-modal-mask": {
//     boxShadow: `inset 0 0 15px #fff`,
//     // background: token.blue1,
//   },
//   "my-modal-header": {
//     border: `100px solid #333`,
//   },
//   "my-modal-footer": {
//     // color: token.colorPrimary,
//   },
//   "my-modal-content": {
//     border: "1px solid #333",
//   },
// }));

const ModalView = ({ visible, children, onClose, ...rest }) => {
  // const token = useTheme();
  // const { styles } = useStyle();
  const modalStyles = {
    header: {
      // borderLeft: `5px solid ${token.colorPrimary}`,
      border: `100px solid #ffff`,
      borderRadius: 100,
      //   paddingInlineStart: 5,
    },
    // body: {
    //   boxShadow: 'inset 0 0 5px #999',
    //   borderRadius: 5,
    // },
    mask: {
      backdropFilter: "blur(10px)",
    },
    // footer: {
    //   borderTop: "1px solid #333",
    // },
    // content: {
    //   boxShadow: '0 0 30px #999',
    // },
  };

  // const classNames = {
  //   body: styles["my-modal-body"],
  //   mask: styles["my-modal-mask"],
  //   header: styles["my-modal-header"],
  //   footer: styles["my-modal-footer"],
  //   content: styles["my-modal-content"],
  // };
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      {...rest}
      styles={modalStyles}
      // classNames={classNames}
    >
      {children}
    </Modal>
  );
};

export default ModalView;
